export default __webpack_public_path__ + "pacer-logo-white.png";